import { __assign } from "tslib";
import { combineReducers } from 'redux';
import types from '../../state/types';
import config from '../../constants/global-unreads-count.config';
import { shouldFilterChatroom } from '../../state/reducer/chatroomsFilter';
import { success } from '../../utils/promise-middleware-utils';
export var PARTICIPANT_ID_ALL = 'PARTICIPANT_ID_ALL';
export var hashUnreadFilter = function (filter) { return JSON.stringify(filter ? filter.participantIds : [PARTICIPANT_ID_ALL]); };
export var parseUnreadFilter = function (filterHash) { return ({ participantIds: JSON.parse(filterHash) }); };
var normalize = function (chatroomIds) {
    return chatroomIds.reduce(function (acc, chatroomId) {
        acc[chatroomId] = true;
        return acc;
    }, {});
};
var setUnreadChatrooms = function (state, action) {
    var _a, _b;
    var payload = action.payload;
    var resyncCountdown = config.maxTrackableUnreads - config.maxUnreadsCount;
    var numberOfUnreadsReceivedFromServer = payload.length;
    var exceedsMaxTrackable = numberOfUnreadsReceivedFromServer > config.maxTrackableUnreads;
    if (exceedsMaxTrackable) {
        return __assign(__assign({}, state), (_a = {}, _a[hashUnreadFilter(action.meta.filter)] = { resyncCountdown: resyncCountdown }, _a));
    }
    return __assign(__assign({}, state), (_b = {}, _b[hashUnreadFilter(action.meta.filter)] = { chatrooms: normalize(payload) }, _b));
};
var getMatchedFilters = function (state, chatroom) {
    return Object.keys(state)
        .map(parseUnreadFilter)
        .filter(function (filter) {
        return shouldFilterChatroom(chatroom, { participantIds: filter.participantIds });
    })
        .map(hashUnreadFilter);
};
var isOverflow = function (state) {
    return 'resyncCountdown' in state;
};
var setChatroomAsUnreadInFilter = function (state, chatroomId) {
    var _a;
    if (isOverflow(state)) {
        return state;
    }
    if (Object.keys(state.chatrooms).length === config.maxTrackableUnreads) {
        return {
            resyncCountdown: config.maxTrackableUnreads - config.maxUnreadsCount,
        };
    }
    return {
        chatrooms: __assign(__assign({}, state.chatrooms), (_a = {}, _a[chatroomId] = true, _a))
    };
};
var setChatroomAsReadInFilter = function (state, chatroomId) {
    if (isOverflow(state)) {
        return {
            resyncCountdown: Math.max(0, (state.resyncCountdown || 0) - 1)
        };
    }
    if (state.chatrooms[chatroomId]) {
        var chatrooms = __assign({}, state.chatrooms);
        delete chatrooms[chatroomId];
        return { chatrooms: chatrooms };
    }
    return state;
};
var setChatroomReadState = function (state, chatroom, isRead) {
    var set = isRead ? setChatroomAsReadInFilter : setChatroomAsUnreadInFilter;
    if (!chatroom) {
        return state;
    }
    var matchedFilters = getMatchedFilters(state, chatroom);
    var newState = __assign({}, state);
    matchedFilters.forEach(function (filterHash) { return newState[filterHash] = set(state[filterHash], chatroom.id); });
    return newState;
};
var setChatroomAsUnread = function (state, chatroom) { return setChatroomReadState(state, chatroom, false); };
var setChatroomAsRead = function (state, chatroom) { return setChatroomReadState(state, chatroom, true); };
var byFilter = function (state, action) {
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case success(types.SET_UNREAD_CHATROOMS):
            return setUnreadChatrooms(state, action);
        case types.ADD_MESSAGE: {
            var _a = action.meta.chatroom, _b = (_a === void 0 ? {} : _a).lastReadMessageSequence, lastReadMessageSequence = _b === void 0 ? 0 : _b;
            return action.messageSentByCurrentUser ||
                action.message.isSilent ||
                action.message.sequence <= lastReadMessageSequence
                ? state
                : setChatroomAsUnread(state, action.meta.chatroom);
        }
        case types.HANDLE_ROOM_UNARCHIVED:
        case success(types.SET_LAST_MESSAGE_UNREAD):
            return setChatroomAsUnread(state, action.meta.chatroom);
        case success(types.UNARCHIVE_ROOM):
            return setChatroomAsUnread(state, unarchive(action.meta.chatroom));
        case success(types.UNARCHIVE_ROOMS):
            return action.meta.chatrooms.reduce(function (prev, chatroom) { return setChatroomAsUnread(prev, unarchive(chatroom)); }, state);
        case types.MARK_CHATROOM_READ:
            return setChatroomAsRead(state, action.meta.chatroom);
        case success(types.SET_MESSAGES_READ):
            return setChatroomAsRead(state, action.meta.chatroom);
        default:
            return state;
    }
};
var unarchive = function (room) { return (__assign(__assign({}, room), { isArchived: false })); };
export var unreadChatroomCountReducer = combineReducers({
    byFilter: byFilter
});
